module.exports = __webpack_public_path__ + "static/media/banner_ticket_1ab98bafac9fdbf2bf1bb60207ac3abea.webp";